











import { Vue, Component } from 'vue-property-decorator'
@Component({})
export default class StartPage extends Vue {
  startTest() {
    this.$emit('startTest')
  }
}
